import script from "./VehicleDetailModal.vue?vue&type=script&setup=true&name=VehicleDetailModal&lang=js"
export * from "./VehicleDetailModal.vue?vue&type=script&setup=true&name=VehicleDetailModal&lang=js"

import "./VehicleDetailModal.vue?vue&type=style&index=0&id=9daf3368&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9daf3368"]])

export default __exports__